'use client';

import { forwardRef } from 'react';
import { createPolymorphicComponent, NavLink as MantineNavLink } from '@mantine/core';
import type { NavLinkProps as MantineNavLinkProps } from '@mantine/core';

import type { LockedPolymorphic, LockedProps } from '../types';

export type NavLinkProps = Omit<MantineNavLinkProps, LockedProps>;

const _NavLink = forwardRef<HTMLAnchorElement, NavLinkProps>((props, ref) => (
  <MantineNavLink ref={ref} {...props} />
));

_NavLink.displayName = 'NavLink';

export const NavLink = createPolymorphicComponent<'a', NavLinkProps>(_NavLink) as LockedPolymorphic<
  'a',
  NavLinkProps
>;
